<template>
  <div class="add-calendar">
    <WrapperLink
      :icon="svgIcons.arrow"
      link="link"
      class="event-btn btn btn-primary calendar-link"
    >
      <a class="wrapper base" ref="calendar"></a>
    </WrapperLink>
  </div>
</template>

<script>
//require('add-to-calendar-buttons');
import {
  createCalendar,
  closeCalenderOnMouseDown,
  addToCalendar
} from "@/plugins/addToCalendar";
import WrapperLink from "@/components/elements/WrapperLink";

export default {
  name: "add-to-calendar",
  props: {
    title: String,
    start: String / Number,
    end: String / Number,
    address: String,
    description: String
  },
  data() {
    return {
      myCalendar: null
    };
  },
  methods: {
    initCalendar() {
      const VM = this,
        startDate = VM.start.replace(/-/g, "/"),
        endDate = VM.end.replace(/-/g, "/");
      this.myCalendar = createCalendar({
        options: {
          label: "Legg til i kalender"
        },
        data: {
          // Event title
          title: VM.title,
          // Event start date
          start: new Date(startDate),
          // Event duration (IN MINUTES)
          duration: "allday",
          // You can also choose to set an end time
          // If an end time is set, this will take precedence over duration
          end: new Date(endDate),
          // Event Address
          address: VM.address,
          // Event Description
          description: VM.description
        }
      });
      this.$refs.calendar.appendChild(this.myCalendar);
    }
  },
  mounted() {
    this.initCalendar();
  },
  components: {
    WrapperLink
  }
};
</script>

<style lang="scss">
.single-event .event-btn a.wrapper {
  padding: 0 !important;
}

.add-calendar {
  position: relative;
  z-index: 9999;
  .add-to-calendar-widget .add-to-calendar-dropdown {
    background-color: #fff !important;
    border-radius: 0;
    border: 2px solid #2a2e34;
    padding: 10px;
    a {
      color: #2a2e34 !important;
      opacity: 1;
      background-color: #fff !important;
      &:before {
        content: none;
        display: none;
      }
      &:hover {
        color: #fff !important;
        background-color: #2a2e34 !important;
      }
    }
  }
  .add-to-calendar-widget {
    label {
      padding: 10px;
      display: block;
      font-weight: 700 !important;
    }
  }
}
</style>
